<template lang="pug" src="./move.pug"></template>

<script>
import vSelect from 'vue-select'
import MoveEstablishmentModal from '../../../registration/establishments/MoveEstablishmentModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'EstablishmentsMove',

  components: {
    vSelect,
    PageTitle,
    FilterPortlet,
    ButtonPrimary,
    MoveEstablishmentModal
  },

  data () {
    return {
      establishmentList: [],
      establishmentOrigin: null,
      establishmentDestiny: null,
      deleteEstablishmentOrigin: true,
      establishimentsUrl: 'establishment/list'
    }
  },

  methods: {
    loadEstablishments (search) {
      if (search.length) {
        const filters = this.mountFilters({
          ascending: 1,
          orderBy: 'nome',
          page: 1,
          limit: 5,
          query: {
            nome: search
          }
        })

        this.$store.dispatch('getEstablishments', filters)
          .then((response) => {
            if (response.elements.length === 0) {
              this.establishmentList = []
            } else {
              this.establishmentList = response.elements
            }
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error.message)
          })
      }
    },

    mountFilters (pagination) {
      const filters = {}
      const atributosValores = []
      for (const key in pagination.query) {
        filters[key] = pagination.query[key]
      }
      return {
        atributosValores,
        filters,
        ...pagination,
        url: this.establishimentsUrl
      }
    },

    handleClearList () {
      this.establishmentList = []
    },

    validate () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            if (this.establishmentOrigin.id !== this.establishmentDestiny.id) {
              this.$store.dispatch('setSelectedEstablishmentsMoveEstablishment', {
                establishmentOrigin: this.establishmentOrigin,
                establishmentDestiny: this.establishmentDestiny,
                deleteEstablishmentOrigin: this.deleteEstablishmentOrigin
              })
              this.moveEstablishmentModal()
            }
          }
        })
    },

    moveEstablishmentModal () {
      $('#moveEstablishmentModal').modal({ backdrop: 'static', keyboard: false })
    },

    back () {
      this.$router.push(PATHS.LIST_ESTABLISHMENTS)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Move.vue?1ae0390f